import React from "react";
import TextField from "@material-ui/core/TextField";
import { Select, MenuItem, InputLabel, FormControl } from '@material-ui/core';

// دوره کتاب خوانی
class Books extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      FullName: "",
      PhoneNumber: "",
      Age: "",
      ChildCount: "",
      MarrigeStatus: "",
    };
  }

  ChangeHandler = (e) => {
    const { HandleData } = this.props;
    this.setState({ [e.target.name]: e.target.value });
    HandleData(this.state, "step3");
  };

  render() {
    return (
      <div className="row">
        <div className="col-12">
          <div className="row mt-3 w-100">
            <div className="col-12">
              <TextField
                className="w-100"
                name="FullName"
                label="نام و نام خانوادگی"
                defaultValue={this.state.FullName}
                onChange={this.ChangeHandler}
                variant={"outlined"}
                color="secondary"
              />
            </div>
          </div>
          <div className="row mt-3 w-100">
            <div className="col-12">
              <TextField
                className="w-100"
                name="PhoneNumber"
                label="شماره تماس"
                defaultValue={this.state.PhoneNumber}
                type="number"
                onChange={this.ChangeHandler}
                variant={"outlined"}
                color="secondary"
              />
            </div>
          </div>
          <div className="row mt-3 w-100">
            <div className="col-12">
              <TextField
                className="w-100"
                name="Age"
                label="سن"
                defaultValue={this.state.Age}
                type="number"
                onChange={this.ChangeHandler}
                variant={"outlined"}
                color="secondary"
              />
            </div>
          </div>
          <div className="row mt-3 w-100">
            <div className="col-12">
              <FormControl>
                <InputLabel id='marrige-lable'>
                  وضعیت تاهل
                </InputLabel>
                <Select
                  labelId='marrige-lable'
                  className="w-100"
                  name="MarrigeStatus"
                  label="وضعیت تاهل"
                  defaultValue={this.state.MarrigeStatus}
                  onChange={this.ChangeHandler}
                  variant={"outlined"}
                  color="secondary"
                >
                  {['مطلقه', 'متاهل', 'مجرد'].map((item, index) => <MenuItem value={item} key={`Marrige-${item}-${index}`}>
                    {item}
                  </MenuItem>)}
                </Select>
              </FormControl>
              {/* <TextField
                className="w-100"
                name="MarrigeStatus"
                label="وضعیت تاهل"
                defaultValue={this.state.MarrigeStatus}
                onChange={this.ChangeHandler}
                variant={"outlined"}
                color="secondary"
              /> */}
            </div>
          </div>
          <div className="row mt-3 w-100">
            <div className="col-12">
              <TextField
                className="w-100"
                name="ChildCount"
                type="number"
                label="تعداد فرزند"
                defaultValue={this.state.ChildCount}
                onChange={this.ChangeHandler}
                variant={"outlined"}
                color="secondary"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Books;
